// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__wWn-q","inner":"Form_inner__1VH4k","range":"Form_range__1WMgm","name":"Form_name__2zZUV","actions":"Form_actions__2UNeN"};